import { APP_BASE_HREF } from '@angular/common';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './components/auth/auth.guard';
import { FleetAccessGuard } from './components/auth/fleet-access.guard';
import { MonitorProfileGuard } from './components/auth/monitor.profile.guard';
import { LoginTemplateComponent } from './components/pages/login-template/login-template.component';
import { RedirectModule } from './components/pages/redirect/redirect.module';


const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./components/pages/redirect/redirect.module').then(
        (m) => m.RedirectModule
      ),
  },
  {
    path: 'home',
    canActivate: [AuthGuard, MonitorProfileGuard, FleetAccessGuard],
    loadChildren: () =>
      import('./components/pages/home-template/home-template.module').then(
        (m) => m.HomeTemplateModule
      ),
  },
  {
    path: 'login',
    component: LoginTemplateComponent,
  },
  {
    path: 'veiculo-selecao',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./components/pages/veiculo-selecao/veiculo-selecao.module').then(
        (m) => m.VeiculoSelecaoModule
      ),
  },
  {
    path: 'app-fields',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./components/pages/servicos-pwa/servicos.module').then(
        (m) => m.ServicosPwaModule
      ),
  },
  {
    path: 'inventario/pendencia',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './components/pages/inventario-pendencia/inventario-pendencia-base.module'
      ).then((m) => m.InventarioPendenciaBaseModule),
  },
  {
    path: 'rastreio',
    loadChildren: () =>
      import('./components/pages/rastreio/rastreio.module').then(
        (m) => m.RastreioModule
      ),
  },
  {
    path: 'rastreio-suporte',
    loadChildren: () =>
      import(
        './components/pages/rastreio-suporte/rastreio-suporte.module'
      ).then((m) => m.RastreioSuporteModule),
  },
  {
    path: 'upload-driver-license',
    loadChildren: () =>
      import('./components/pages/upload-driver-license/upload-driver-license.module').then(m => m.UploadDriverLicenseModule)
  },
  {
    path: 'servico-status/:id',
    loadChildren: () =>
      import('./components/pages/servico-status/servico-status.module').then(
        (m) => m.ServicoStatusModule
      ),
  },
  {
    path: 'home/ocorrencias/procuracoes',
    loadChildren: () =>
      import('./components/pages/ocorrencias/procuracoes/procuracoes.module').then(
        (m) => m.ProcuracoesModule
      ),
  },

  {
    path: 'formulario-previsao-chegada/:hash',
    loadChildren: () =>
      import('./components/pages/formulario-previsao-chegada/formulario-previsao-chegada.module').then(
        (m) => m.FormularioPrevisaoChegadaModule
      ),
  },
  {
    path: 'formulario-aceite-servico/:hash',
    loadChildren: () =>
      import('./components/pages/formulario-aceite-servico/formulario-aceite-servico.module').then(
        (m) => m.FormularioAceiteServicoModule
      ),
  },
  {
    path: 'formulario-acompanhamento-servico/:hash',
    loadChildren: () =>
      import('./components/pages/formulario-acompanhamento-servico/formulario-acompanhamento-servico.module').then(
        (m) => m.FormularioAcompanhamentoServicoModule
      ),
  },
  {
    path: 'acompanhamento-servico/:hash',
    loadChildren: () =>
      import('./components/pages/acompanhamento-servico/acompanhamento-servico.module').then(
        (m) => m.AcompanhamentoServicoModule
      ),
  },
  {
    path: 'movimentacao/base',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import(
        './components/pages/controle-movimentacao-base/controle-movimentacao-base.module'
      ).then((m) => m.ControlemovimentacaoBaseModule),
  },
  {
    path: 'area-atendimento',
    loadChildren: () =>
      import(
        './components/pages/cobertura-atendimento/cobertura-atendimento.module'
      ).then((m) => m.CoberturaAtendimentoModule),
  },
  {
    path: 'terceiros-cadastro',
    loadChildren: () =>
      import(
        './components/pages/cadastro-terceiros-form/cadastro-terceiro-form.module'
      ).then((m) => m.CadastroTerceiroFormModule),
  },
  {
    path: 'confirm-email',
    loadChildren: () =>
      import(
        './components/pages/confirm-email/confirm-email.module'
      ).then((m) => m.ConfirmEmailModule),
  },
  {
    path: 'diagnostico-remoto',
    loadChildren: () =>
      import(
        './components/pages/fagbot/fagbot-main.module'
      ).then(m => m.FagbotMainModule)
  },
  {
    path: 'intercom',
    loadChildren: () =>
      import(
        './components/pages/intercom/intercom.module'
      ).then(m => m.IntercomModule)
  },
  {
    canActivate: [AuthGuard, MonitorProfileGuard],
    path: 'terceiros',
    loadChildren: () =>
      import(
        './components/pages/terceiros-admin-app/terceiros-admin-app.module'
      ).then(m => m.TerceirosAdminAppModule)
  },
  { path: '**', component: RedirectModule },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      relativeLinkResolution: 'legacy',
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
  providers: [{ provide: APP_BASE_HREF, useValue: '/' }],
})
export class AppRoutingModule {
}
